var _style, _polygon, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArnoldLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85.7 78.9",
    style: {
      enableBackground: "new 0 0 85.7 78.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F48534;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#727377;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      display: "none",
      overflow: "visible"
    },
    width: 352,
    height: 300,
    xlinkHref: "A6E21069.png",
    transform: "matrix(0.2333 0 0 0.2333 1.7294 1.7884)"
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27.9,13.9 12.5,42.9 28,71.8 58,71.8 73.3,42.7 58.2,13.9 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.2,22.8h-1.6c-1.3,2.5-2.7,5.1-4.2,7.7c-3.3,5.7-6.7,10.9-10,15.7h3.1l4.7-8.7h7.7l1,8.7h4 C46.2,36.5,44.2,22.8,44.2,22.8z M37,35.8l4.8-8.2c0,0,1.1,6.7,1.7,8.3L37,35.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.4,60.8c1-3.6,1.9-7.4,2.7-11.5c0.7-3.5,1.3-6.8,1.8-10.1h3.5c0,0-1.3,4.1-2,8.5h12.9c0,0,1.7-8.7,1.7-9.7 h3.7c0,0-3.6,13.1-4.8,22.9h-3.6L52,49.5H39.1c0,0-1.6,8.3-2.1,11.3L33.4,60.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.9,39.4l-6,0.7L1.1,39l4.4-0.4l0-0.1l-4.1-1.8l0.2-1L6,35.4l0-0.1L2,33.6l0.2-1.1L7.6,35l-0.2,1l-4.2,0.5 l0,0l3.9,1.8L6.9,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.3,32.6l-5.5-1.9L4,27.1l0.8,0.3L4,30l1.5,0.5l0.8-2.4l0.8,0.3l-0.8,2.4l1.5,0.5l0.9-2.6l0.8,0.3L8.3,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.9,26L6,22.9L6.6,22l2.1,1.3l1.4-2.3L8,19.7l0.6-0.9l4.9,3.1l-0.6,0.9l-2.1-1.3l-1.4,2.3l2.1,1.3L10.9,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.5,15.1c0.5,0.4,0.8,0.9,1,1.3s0.2,0.9,0.1,1.4c-0.1,0.5-0.3,0.9-0.6,1.3c-0.3,0.4-0.7,0.6-1.2,0.8 c-0.4,0.1-0.9,0.2-1.4,0c-0.5-0.1-1-0.4-1.4-0.8c-0.5-0.4-0.8-0.9-1-1.3c-0.2-0.5-0.2-0.9-0.1-1.4s0.3-0.9,0.6-1.3 c0.3-0.4,0.7-0.6,1.2-0.8c0.4-0.1,0.9-0.2,1.4,0C14.5,14.4,15,14.7,15.5,15.1z M14.8,15.9c-0.5-0.4-1-0.7-1.4-0.7s-0.8,0.2-1.2,0.5 c-0.3,0.4-0.4,0.8-0.4,1.2c0.1,0.5,0.3,0.9,0.8,1.3c0.5,0.4,1,0.7,1.4,0.7c0.5,0,0.8-0.2,1.2-0.5c0.3-0.4,0.4-0.8,0.4-1.2 S15.3,16.3,14.8,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.5,16.3l-3.7-4.5l0.8-0.7l3.2,3.8l2-1.6l0.6,0.7L18.5,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.8,12.3l-1.7,1l-3-5l1.7-1c0.5-0.3,1-0.5,1.5-0.5c0.5,0,0.9,0.1,1.3,0.4s0.8,0.6,1.1,1.2 c0.3,0.5,0.5,1,0.5,1.5c0,0.5-0.1,0.9-0.3,1.4C24.7,11.6,24.3,12,23.8,12.3z M22.5,12l0.7-0.5c1-0.6,1.2-1.5,0.5-2.7 c-0.7-1.1-1.6-1.4-2.6-0.8l-0.8,0.5L22.5,12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27,4.1l1.1-0.4l2.2,2l0.1,0l0.5-2.9L32,2.4l-0.8,4.1l0.7,2.1l-1,0.3l-0.7-2.1L27,4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39,4c0.1,0.6,0.1,1.2-0.1,1.6c-0.2,0.5-0.4,0.9-0.8,1.2c-0.4,0.3-0.8,0.5-1.3,0.6c-0.5,0.1-1,0-1.4-0.1 s-0.8-0.5-1.1-0.9c-0.3-0.4-0.5-0.9-0.6-1.5c-0.1-0.6-0.1-1.2,0.1-1.6c0.2-0.5,0.4-0.9,0.8-1.2c0.4-0.3,0.8-0.5,1.3-0.6 c0.5-0.1,1,0,1.4,0.1c0.4,0.2,0.8,0.5,1.1,0.9C38.7,2.9,38.9,3.4,39,4z M38,4.2c-0.1-0.7-0.3-1.1-0.7-1.4c-0.4-0.3-0.8-0.4-1.2-0.3 c-0.5,0.1-0.8,0.3-1.1,0.7c-0.2,0.4-0.3,0.9-0.2,1.6c0.1,0.7,0.3,1.1,0.7,1.4s0.8,0.4,1.2,0.3c0.5-0.1,0.8-0.3,1.1-0.7 C38,5.4,38.1,4.9,38,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.3,1.1l1.1,0l-0.1,3.8c0,0.4-0.1,0.8-0.3,1.1c-0.2,0.3-0.5,0.6-0.8,0.7c-0.4,0.2-0.8,0.3-1.2,0.2 c-0.5,0-0.9-0.1-1.2-0.3c-0.4-0.2-0.6-0.4-0.8-0.8s-0.3-0.7-0.3-1.1L40.7,1l1.1,0l-0.1,3.7c0,0.4,0.1,0.7,0.3,0.9 C42.2,5.9,42.6,6,43,6c0.4,0,0.7-0.1,1-0.3c0.2-0.2,0.4-0.5,0.4-0.9L44.3,1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.6,7l0.9-5.7l2.2,0.3c0.7,0.1,1.1,0.4,1.4,0.7s0.4,0.9,0.3,1.4c-0.1,0.4-0.2,0.7-0.4,1s-0.5,0.4-0.9,0.5 l0.9,2.5l-1.2-0.2L49,5.2L47.9,5l-0.3,2.1L46.6,7z M48.1,4.2l1,0.2c0.4,0.1,0.7,0,0.9-0.1c0.2-0.1,0.3-0.4,0.4-0.7 c0-0.3,0-0.6-0.2-0.8c-0.2-0.2-0.4-0.3-0.8-0.4l-1-0.2L48.1,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.9,8.5L56,3.1l3.5,1.3l-0.3,0.8l-2.6-1l-0.6,1.5l2.4,0.9l-0.3,0.8l-2.4-0.9l-0.6,1.5l2.6,1l-0.3,0.8 L53.9,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.5,5.3L62.7,6L62,10.5l0.1,0l3.6-2.7l1.1,0.7l-3,5L63,12.9l2-3.4l0,0L61.5,12l-0.6-0.4l0.7-4.3l0,0l-2,3.4 l-0.9-0.5L61.5,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.6,15.4c-0.4,0.5-0.9,0.8-1.3,1c-0.5,0.2-0.9,0.2-1.4,0.1c-0.5-0.1-0.9-0.3-1.3-0.6 c-0.4-0.3-0.6-0.7-0.8-1.2c-0.1-0.4-0.2-0.9,0-1.4s0.4-1,0.8-1.4c0.4-0.5,0.9-0.8,1.3-1c0.5-0.2,0.9-0.2,1.4-0.1s0.9,0.3,1.3,0.6 s0.6,0.7,0.8,1.2s0.2,0.9,0,1.4C71.3,14.5,71,15,70.6,15.4z M69.8,14.7c0.4-0.5,0.7-1,0.7-1.4c0-0.5-0.2-0.8-0.5-1.2 c-0.4-0.3-0.8-0.4-1.2-0.4s-0.9,0.3-1.3,0.8c-0.4,0.5-0.7,1-0.7,1.4s0.2,0.8,0.5,1.2c0.4,0.3,0.8,0.4,1.2,0.4 C68.9,15.5,69.4,15.2,69.8,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.9,14.9l0.7-0.6l3,3.6l-0.7,0.6l-1.2-1.4l-3.8,3.2l-0.7-0.8l3.8-3.2L72.9,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78,20.2l-4.8,3.2l-0.6-0.9l4.8-3.2L78,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.9,27.8c-0.6,0.3-1.1,0.4-1.6,0.4s-1-0.1-1.3-0.4c-0.4-0.3-0.7-0.6-0.9-1.1c-0.2-0.5-0.3-0.9-0.3-1.4 c0-0.5,0.2-0.9,0.5-1.3c0.3-0.4,0.7-0.8,1.3-1c0.6-0.3,1.1-0.4,1.6-0.4s1,0.1,1.3,0.4s0.7,0.6,0.9,1.1c0.2,0.5,0.3,0.9,0.3,1.4 s-0.2,0.9-0.5,1.3C79.9,27.2,79.4,27.6,78.9,27.8z M78.4,26.9c0.6-0.3,1-0.7,1.2-1.1c0.2-0.4,0.2-0.8-0.1-1.3 c-0.2-0.4-0.5-0.7-1-0.8s-1,0-1.6,0.3c-0.6,0.3-1,0.7-1.2,1.1c-0.2,0.4-0.2,0.9,0,1.3c0.2,0.4,0.5,0.7,1,0.8 C77.3,27.3,77.8,27.2,78.4,26.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.6,33.1L78,34.8l-0.3-0.9l3-3.8l0,0L77,31.2l-0.3-1l5.6-1.7l0.3,0.9l-3,3.8l0,0l3.8-1.1L83.6,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.9,38.6c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.1-0.5,0.1-0.8c0-0.3-0.2-0.6-0.3-0.7c-0.2-0.2-0.4-0.2-0.6-0.2 c-0.2,0-0.3,0.1-0.4,0.2S82.1,36.9,82,37c0,0.2-0.1,0.3-0.1,0.5l-0.1,0.6c0,0.3-0.1,0.6-0.2,0.9c-0.1,0.3-0.2,0.5-0.4,0.7 c-0.2,0.2-0.5,0.3-0.8,0.4c-0.5,0.1-0.9-0.1-1.3-0.4c-0.4-0.3-0.6-0.9-0.7-1.5c-0.1-0.7,0-1.2,0.2-1.7c0.3-0.4,0.7-0.7,1.2-0.8 l0.1,1c-0.3,0.1-0.5,0.2-0.6,0.5c-0.1,0.2-0.2,0.5-0.1,0.9c0,0.3,0.2,0.6,0.3,0.8s0.4,0.3,0.6,0.2c0.2,0,0.4-0.2,0.5-0.4 s0.2-0.5,0.2-0.8l0.1-0.7c0.1-0.5,0.2-0.9,0.4-1.2c0.2-0.3,0.5-0.5,0.9-0.5c0.3,0,0.6,0,0.9,0.2c0.3,0.1,0.5,0.4,0.7,0.7 c0.2,0.3,0.3,0.7,0.4,1.1c0.1,0.4,0,0.8-0.1,1.1c-0.1,0.3-0.3,0.6-0.5,0.8c-0.2,0.2-0.5,0.3-0.8,0.4L82.9,38.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArnoldLogo);
export default __webpack_public_path__ + "static/media/arnold_logo.b7026d07c0ca764bb227ed771d99bf11.svg";
export { ForwardRef as ReactComponent };